import apiClient from "../utils/apiClient";

export const signUpClient = async (data) => {
  try {
    const response = await apiClient.post("/registrar-cliente-web", data);
    return response?.data;
  } catch (error) {
    console.error("Error en el registro:", error);
    throw error;
  }
};

export const loginClient = async (data) => {
  try {
    const response = await apiClient.post("/login-cliente-web", data);
    return response?.data;
  } catch (error) {
    console.error("Error en el inicio de sesión:", error);
    throw error;
  }
};

export const reSendEmail = async (data) => {
  try {
    const response = await apiClient.post("/forgot-password-cliente", data);
    return response?.data;
  } catch (error) {
    console.error("Error en el inicio de sesión:", error);
    throw error;
  }
};

export const resetPassword = async (data) => {
  try {
    const response = await apiClient.post("/reset-password-cliente", data);
    return response?.data;
  } catch (error) {
    console.error("Error en el inicio de sesión:", error);
    throw error;
  }
};

export const successfullSignUp = async (data) => {
  try {
    const response = await apiClient.post("/email_registro_web", data);
    return response?.data;
  } catch (error) {
    console.error("Error en el inicio de sesión:", error);
    throw error;
  }
};

export const comisionUser = async (id) => {
  try {
    const response = await apiClient.get(`/comision_cliente/${id}`);
    return response?.data;
  } catch (error) {
    console.error("Error en el inicio de sesión:", error);
    throw error;
  }
};
